module.exports = __webpack_public_path__ + "static/media/Client2.589ec6ec.png";